import { z } from "zod";
export const ControlledAiAuditResultV1Schema = z.object({
    schemaVersion: z.literal("controlled-ai-audit.v1.0"),
    requirementId: z.literal("AI-008"),
    ok: z.boolean(),
    humanContinuationRequired: z.boolean(),
    detail: z.string().optional(),
}).strict();
export function recordAiAuditEvent(input) {
    const malformed = input.payload.trim().length === 0;
    return ControlledAiAuditResultV1Schema.parse({
        schemaVersion: "controlled-ai-audit.v1.0",
        requirementId: "AI-008",
        ok: !malformed,
        humanContinuationRequired: true,
        detail: malformed ? "malformed_or_low_confidence" : undefined,
    });
}
//# sourceMappingURL=audit.js.map